import { axiosWithAuth } from "../utils/customAxios";

const welcomeJourneyService = {

    getKnowledgebaseLink: async (): Promise<string> => {
        const response = await axiosWithAuth.get('systemsetting/knowledgebaselink');
        return response.data.message;
    },
    getProductTourLink: async (): Promise<string> => {
        const response = await axiosWithAuth.get('systemsetting/producttourlink');
        return response.data.message;
    },
    getExpertChatLink: async (): Promise<string> => {
        const response = await axiosWithAuth.get('systemsetting/expertchatlink');
        return response.data.message;
    },
    isWelcomeJourneySeen: async (): Promise<boolean> => {
        const response = await axiosWithAuth.get('welcomejourney/iswelcomejourneyseen');
        return response.data;
    },
    updateWelcomeJourney: async (): Promise<number> => {
        const response = await axiosWithAuth.put('welcomejourney/updateWelcomeJourney');
        return response.data;
    }
};

export default welcomeJourneyService;